<dtm-ui-error [errorMessage]="'dtmUi.serverErrorMessage' | transloco : { code: state?.status }" (reload)="reloadPage()"></dtm-ui-error>
